'use client'

import { map } from 'lodash'
import { useTranslations } from '@/lib/next-shim'

import { useListPrioritizedMeetingLinksQuery } from '@/core/graphql/hooks'
import { Link } from '@/lib/i18n/settings'

export default function PrioritizedMeetingLinks() {
  const t = useTranslations()

  const { data, loading } = useListPrioritizedMeetingLinksQuery()

  const meetingLinks = data?.prioritizedMeetingLinks

  return (
    <div>
      {loading ? (
        <div className="mx-auto grid gap-4 max-w-lg md:max-w-none md:grid-cols-2 lg:grid-cols-3">
          <div className="flex flex-col min-w-[300px] bg-white border border-primary overflow-hidden rounded-lg shadow-lg">
            <div className="animate-pulse flex flex-1 flex-col p-6">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-2 mt-6 bg-slate-200 rounded"></div>
              <div className="h-2 mt-3 bg-slate-200 rounded"></div>
            </div>
          </div>
          <div className="hidden md:flex flex-col min-w-[300px] bg-white border border-primary overflow-hidden rounded-lg shadow-lg">
            <div className="animate-pulse flex flex-1 flex-col p-6">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-2 mt-6 bg-slate-200 rounded"></div>
              <div className="h-2 mt-3 bg-slate-200 rounded"></div>
            </div>
          </div>
          <div className="hidden lg:flex flex-col min-w-[300px] bg-white border border-primary overflow-hidden rounded-lg shadow-lg">
            <div className="animate-pulse flex flex-1 flex-col p-6">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-2 bg-slate-200 rounded col-span-1"></div>
              </div>
              <div className="h-2 mt-6 bg-slate-200 rounded"></div>
              <div className="h-2 mt-3 bg-slate-200 rounded"></div>
            </div>
          </div>
        </div>
      ) : (
        <div className="mx-auto grid max-w-lg gap-5 md:max-w-none md:grid-cols-2 lg:grid-cols-3">
          {map(meetingLinks, (meetingLink) => (
            <div key={meetingLink._id} className="flex flex-col bg-white shadow-lg border border-primary overflow-hidden rounded-lg text-left">
              <div className="flex flex-1 flex-col space-y-3 justify-between p-6">
                <Link href={`/meeting-links/${meetingLink.slug}`}>
                  <h3 className="text-xl font-bold text-gray-900">{meetingLink.name}</h3>
                </Link>
                <p className="text-sm text-gray-500">{meetingLink.description}</p>
                <div className="flex flex-wrap gap-1 text-sm text-gray-500">
                  {meetingLink.specialities.map((speciality) => (
                    <span
                      key={speciality.code}
                      className="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-gray-500 ring-1 ring-inset ring-gray-200"
                    >
                      <svg className="h-1.5 w-1.5 fill-primary" viewBox="0 0 6 6" aria-hidden="true">
                        <circle cx={3} cy={3} r={3} />
                      </svg>
                      {speciality.name}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
